export default "__VITE_ASSET__wiSC6ZKL__"